module.exports = __webpack_public_path__ + "static/vf-button-men-shoes.e76a4b44.svg";